<template>
  <div id='ActiveUserByMonth'></div>
</template>

<script>
import G2 from '@antv/g2';
import chartMixin from '../../chartMixin';

export default {
  name: 'ActiveUserByMonth',
  mixins: [chartMixin],
  data() {
    return {
      demoData: [{ month: 1, mark: 'monthAppActive', count: 12 }],
      serviceList: [
        { value: 'monthAppActive', name: 'APP活跃用户' },
        { value: 'monthHardActive', name: '硬件活跃用户' },
        { value: 'allActive', name: '全部活跃' },
        { value: 'total', name: '全部活跃' },
      ],
    };
  },
  methods: {
    initData() {
      this.chart = new G2.Chart({
        container: 'ActiveUserByMonth',
        forceFit: true,
        height: this.height,
        padding: [30, 20, 30, 50],
      });
      this.chart
        .source(this.data, {
          month: {
            type: 'cat',
          },
          mark: {
            type: 'cat',
            formatter: value => {
              let service = this.serviceList.find(item => item.value === value);
              return service ? service.name : '';
            },
          },
        })
        .tooltip({
          showTitle: false,
        });
      // 图例
      this.chart
        .legend({
          position: 'top',
          title: null,
          marker: 'square',
          clickable: false,
        })
        .interval()
        .position('month*count')
        .color('mark', ['#4e82fb', '#ffc934', '#26c9a8'])
        .adjust([
          {
            type: 'dodge',
            marginRatio: 1 / 32,
          },
        ]);

      this.chart.render();
    },
  },
};
</script>
